import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose class names (ported from Play sc-marketing lib/cn.ts): clsx for
 * conditional arrays/objects, tailwind-merge so the LAST conflicting Tailwind
 * utility wins — which is what lets a consumer's `className` override a
 * primitive's defaults (`cn('p-2', 'p-4')` → `'p-4'`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
